export function valueOrDefault<TValue>(value: TValue, defaultValue: TValue): TValue {
    return value !== undefined && value !== null
        ? value
        : defaultValue;
}